export class DataIdentifierOptionsFormatHelper {
    static _textOptionsFormats = {
        generationDate: {
            text: "Data de Geração",
            value: "{generation_date}"
        },
        referenceDate: {
            text: "Data de Referencia",
            value: "{reference_date}"
        },
        documentDate: {
            text: "Data do Documento",
            value: "{document_date}"
        },
        documentDay: {
            text: "Dia do Documento",
            value: "{document_day}"
        },
        documentMonth: {
            text: "Mês do Documento",
            value: "{document_month}"
        },
        documentMonthPt: {
            text: "Mês do Documento (PT)",
            value: "{document_month_pt}"
        },
        documentYear: {
            text: "Ano do Documento",
            value: "{document_year}"
        },
        referenceDay: {
            text: "Dia da Data de Referencia",
            value: "{reference_day}"
        },
        referenceMonth: {
            text: "Mês da Data de Referencia",
            value: "{reference_month}"
        },
        referenceMonthPt: {
            text: "Mês da Data de Referencia (PT)",
            value: "{reference_month_pt}"
        },
        referenceYear: {
            text: "Ano da Data de Referencia",
            value: "{reference_year}"
        },
        generationDay: {
            text: "Dia da Geração",
            value: "{generation_day}"
        },
        generationMonth: {
            text: "Mês da Geração",
            value: "{generation_month}"
        },
        generationMonthPt: {
            text: "Mês da Geração (PT)",
            value: "{generation_month_pt}"
        },
        generationYear: {
            text: "Ano da Geração",
            value: "{generation_year}"
        },
        lineCode: {
            text: "Código da Linha",
            value: "{line_code}"
        },
        lineName: {
            text: "Nome da Linha",
            value: "{line_name}"
        },
        stopCode: {
            text: "Código da Paragem",
            value: "{stop_code}"
        },
        stopCode5Digit: {
            text: "Código da Paragem (5 dígitos)",
            value: "{stop_code_5_digits}"
        },
        stopName: {
            text: "Nome da Paragem",
            value: "{stop_name}"
        },
        schedules: {
            text: "Nome(s) do(s) Horário(s)",
            value: "{schedules}"
        },
        version: {
            text: "Versão",
            value: "{version}"
        },
        directionIdaVolta: {
            text: "Sentido (Ida/Volta/Circular)",
            value: "{direction_ida_volta}"
        },
        directionAscDesc: {
            text: "Sentido (Ascendente/Descendente/Circular)",
            value: "{direction_asc_desc}"
        },
        directionAscDescShort: {
            text: "Sentido (Asc/Desc/Circ)",
            value: "{direction_asc_desc_short}"
        },
        directionGoReturnShort: {
            text: "Sentido (G/R/C)",
            value: "{direction_go_return_short}"
        }
    }

    static getOptionText(option) {
        if(undefined === this._textOptionsFormats[option]) {
            return "";
        }

        return this._textOptionsFormats[option].text;
    }

    static getOptionValue(option) {
        if(undefined === this._textOptionsFormats[option]) {
            return "";
        }

        return this._textOptionsFormats[option].value;
    }

    static getOptionTextFromValue(value) {
        let i = 0;
        for(i in this._textOptionsFormats) {
            if(this._textOptionsFormats[i].value === value) {
                return this._textOptionsFormats[i].text;
            }
        }

        return "";
    }
}
